export default __webpack_public_path__ + "static/media/hindi_lang.3cf53cbf.png";